import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataService';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  pushVersion: string;
  pushAnio: string;

  constructor(private data : DataService) {
    this.data.getVersionApi()
    .subscribe(sucess => 
      {
        this.pushVersion = sucess;
        this.pushAnio = new Date().getFullYear().toString();
    });
   }

  ngOnInit() {
  }

}
